import { render, staticRenderFns } from "./provinceMunicipality.vue?vue&type=template&id=023b65c4&"
import script from "./provinceMunicipality.vue?vue&type=script&lang=ts&"
export * from "./provinceMunicipality.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports